import { render } from "./invitationManagement.vue?vue&type=template&id=833f480c&scoped=true"
import script from "./invitationManagement.vue?vue&type=script&lang=js"
export * from "./invitationManagement.vue?vue&type=script&lang=js"

import "./invitationManagement.vue?vue&type=style&index=0&id=833f480c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833f480c"]])

export default __exports__